var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"block"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.current_page,"page-sizes":this.$store.state.pageSizes,"page-size":_vm.page_size,"layout":_vm.layout,"total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }